import PackmanagerJobLink from "components/pages/schedule/PackmanagerJobLink";
import React from "react";
import renderToString from "./renderToString";

export default function packmanagerJobLinkRenderer({ jobId, applicationContext, prefix }) {
  return renderToString(<PackmanagerJobLink applicationContext={applicationContext} jobId={jobId} prefix={prefix} />);
}
